export default "__VITE_ASSET__DWIESXg7__"